import e from"@emotion/styled";import{setRadius as t,setFontSize as r,setChipVariants as n}from"../../utils/generateStyles.js";const p=e.div`
  label: chip;
  display: inline-flex;
  padding: 2px 11px;
  align-items: center;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  ${i=>t(i.radius)}
  ${i=>r(i.size)}
  ${i=>n(i.variant)}
  ${i=>i.isFullWidth&&{width:"100%"}}
`,a=e.div`
  label: chip-children-wrapper;
  display: inline-flex;
  flex-grow: 1;
  ${i=>i.isAlignCenter&&{justifyContent:"center"}}
`,l=e.div`
  label: chip-close-wrapper;
  padding-right: 8px;
  display: flex;
  & > * {
    cursor: pointer;
  }
`;export{a as ChipChildrenWrapperStyled,l as ChipCloseWrapperStyled,p as ChipStyled};
